<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>통계</p>
                <div class="area_button">
                    <button type="button" @click="downloadFile">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_tab">
                        <div
                            :class="{ selected: state.category === '' }"
                            @click="
                                state.category = '';
                                router.push({ name: 'statisticsCommon', query: { category: state.category } });
                                fnGetData();
                            "
                        >
                            <span>전체</span>
                        </div>
                        <div
                            :class="{ selected: state.category === '상담팀' }"
                            @click="
                                state.category = '상담팀';
                                router.push({ name: 'statisticsCommon', query: { category: state.category } });
                                fnGetData();
                            "
                        >
                            <span>상담팀</span>
                        </div>
                        <div
                            :class="{ selected: state.category === '청소년' }"
                            @click="
                                state.category = '청소년';
                                router.push({ name: 'statisticsCommon', query: { category: state.category } });
                                fnGetData();
                            "
                        >
                            <span>청소년팀</span>
                        </div>
                        <div
                            :class="{ selected: state.category === '현장팀' }"
                            @click="
                                state.category = '현장팀';
                                router.push({ name: 'statisticsCommon', query: { category: state.category } });
                                fnGetData();
                            "
                        >
                            <span>현장팀</span>
                        </div>
                        <div
                            :class="{ selected: state.category === '상담팀,청소년' }"
                            @click="
                                state.category = '상담팀,청소년';
                                router.push({ name: 'statisticsCommon', query: { category: state.category } });
                                fnGetData();
                            "
                        >
                            <span>상담팀+청소년팀</span>
                        </div>
                    </div>
                    <div class="area_search">
                        <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button type="button" @click="setDateToToday()">오늘날짜</button>
                            </div>
                        </div>

                        <div>
                            <label>작성일2</label>
                            <div>
                                <div class="datepicker">
                                    <input type="date" id="startDate" v-model="state.startDate2" />
                                </div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate2" /></div>
                                <router-link
                                    :to="{
                                        name: 'statisticsCommon',
                                        query: { category: state.category, startDate: state.startDate2, endDate: state.endDate2 },
                                    }"
                                    target="_blank"
                                    style="border-radius: 5px; border: 1px solid #d9d9d9; padding: 2px 10px; background-color: white"
                                >
                                    새창 비교 검색
                                </router-link>
                            </div>
                        </div>

                        <div>
                            <label>작성일3</label>
                            <div>
                                <div class="datepicker">
                                    <input type="date" id="startDate" v-model="state.startDate3" />
                                </div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate3" /></div>
                                <router-link
                                    :to="{
                                        name: 'statisticsCommon',
                                        query: { category: state.category, startDate: state.startDate3, endDate: state.endDate3 },
                                    }"
                                    target="_blank"
                                    style="border-radius: 5px; border: 1px solid #d9d9d9; padding: 2px 10px; background-color: white"
                                >
                                    새창 비교 검색
                                </router-link>
                            </div>
                        </div>

                        <div>
                            <div>
                                <div class="radio_wrap">
                                    <label>
                                        <input
                                            type="radio"
                                            name="state"
                                            :checked="state.type === 1"
                                            @click="
                                                state.type = 1;
                                                fnGetData();
                                            "
                                        />
                                        <em></em>
                                        <span>상담기록 기준 통계</span>
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="state"
                                            :checked="state.type === 2"
                                            @click="
                                                state.type = 2;
                                                fnGetData();
                                            "
                                        />
                                        <em></em>
                                        <span>기초기록 기준 통계</span>
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="state"
                                            :checked="state.type === 3"
                                            @click="
                                                state.type = 3;
                                                fnGetData();
                                            "
                                        />
                                        <em></em>
                                        <span>연도별 추이</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetData();
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetData()">검색</button>
                        </div>
                    </div>
                </div>
                <template v-if="state.isLoading">
                    <!-- 스피너 사이즈, 굵기 조정 -->
                    <Spinner :spinnerSize="70" :thickness="10"></Spinner>
                </template>
                <template v-else>
                    <Counsel
                        :data="state.data"
                        :sYear="Number(state.startDate.substring(0, 4))"
                        v-if="state.type === 1 && state.data != null && state.data.length > 0"
                    ></Counsel>
                    <Client
                        :data="state.data"
                        :sYear="Number(state.startDate.substring(0, 4))"
                        v-if="state.type === 2 && state.data != null && state.data.length > 0"
                    ></Client>
                    <Year
                        v-if="state.type === 3 && state.data != null && state.data.length > 0"
                        :data="state.data"
                        :startYear="Number(state.startDate.substring(0, 4))"
                        :endYear="Number(state.endDate.substring(0, 4))"
                    ></Year>
                </template>
            </div>
        </div>
    </section>
    <Spinner :is-full-page="true" v-if="state.isGlobalLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        Counsel,
        Client,
        Year,
        useRoute,
    } from "@/BaseComponent";
    import Spinner from "@/components/spinner.vue";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, Counsel, Client, Year, Spinner },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setFullYear(today.getFullYear());
            dayAgo.setMonth(0);
            dayAgo.setDate(1);

            const state = reactive({
                startDate: dayAgo.toLocaleDateString("sv-SE") as string,
                endDate: today.toLocaleDateString("sv-SE") as string,
                startDate2: "" as string,
                endDate2: "" as string,
                startDate3: "" as string,
                endDate3: "" as string,
                category: "" as string,
                type: 1 as 1 | 2 | 3,
                data: [] as Array<types.statistics.StatisticsYearVOForApi>,
                isLoading: false as boolean,
                isGlobalLoading: false as boolean,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            onMounted(() => {
                if (!route.query.category) {
                    state.category = "";
                } else {
                    state.category = String(route.query.category);
                }
                router.replace({ name: "statisticsCommon", query: { category: state.category } });

                if (route.query.startDate && route.query.endDate) {
                    state.startDate = String(route.query.startDate);
                    state.endDate = String(route.query.endDate);
                } else {
                    state.startDate = dayAgo.toLocaleDateString("sv-SE");
                    state.endDate = today.toLocaleDateString("sv-SE");
                }
                fnGetData();
            });

            watch(
                () => route.query.category,
                () => {
                    if (!route.query.category) {
                        state.category = "";
                    } else {
                        state.category = String(route.query.category);
                    }
                    router.replace({ name: "statisticsCommon", query: { category: state.category } });
                    // state.startDate = dayAgo.toLocaleDateString("sv-SE");
                    // state.endDate = today.toLocaleDateString("sv-SE");
                    fnGetData();
                },
            );

            const fnGetData = async () => {
                state.data = [];
                state.isLoading = true;
                const param: types.statistics.ReqStatistics = {
                    category: state.category,
                    sex: "",
                    startDate: state.startDate,
                    endDate: state.endDate,
                    order: null,
                    page: null,
                    size: null,
                    searchType: null,
                    searchText: null,
                };
                let res: types.statistics.ResStatistics | null = null;

                switch (state.type) {
                    case 1:
                        res = await apiService.statistics.counsel(param);
                        break;
                    case 2:
                        res = await apiService.statistics.client(param);
                        break;
                    case 3:
                        res = await apiService.statistics.year(param);
                        break;
                    default:
                        res = await apiService.statistics.counsel(param);
                        break;
                }

                if (res.returnCode === 0) {
                    if (res.data) state.data = res.data;
                } else {
                    console.error(res.description);
                }
                state.isLoading = false;
            };

            const reset = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const setDateToToday = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                } else {
                    fnGetData();
                }
            };
            const changeEndDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                } else {
                    fnGetData();
                }
            };

            const downloadFile = async () => {
                state.isGlobalLoading = true;
                try {
                    const param: types.statistics.ReqStatisticsForExcel = {
                        category: state.category,
                        sex: "",
                        startDate: state.startDate,
                        endDate: state.endDate,
                        order: null,
                        page: null,
                        size: null,
                        searchType: null,
                        searchText: null,
                        type: state.type,
                    };

                    let res = await apiService.statistics.exportExcel(param);
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
                state.isGlobalLoading = false;
            };

            return {
                state,
                reset,
                CommonUtils,
                CommonOptions,
                setDateToToday,
                fnGetData,
                router,
                changeStartDate,
                changeEndDate,
                downloadFile,
            };
        },
    };
</script>
<style scoped>
    .sch_list label:last-child {
        border-right: white;
    }

    .areaGrid td {
        text-align: center;
    }
</style>
